<div
  class="legal-page"
  [class.client-source]="isClientSource()"
  [class.veterinarian]="isVetSource()"
  [class.dark]="theme() === 'dark'"
  [class.light]="theme() === 'light'"
>
  <header class="legal-header">
    <div class="header-inner">
      <div class="logo-mark"></div>
      <span class="header-title">Anihis</span>
    </div>
  </header>

  <main class="legal-content">
    <div class="legal-container">
      <h1 class="page-title">{{ 'legal.impressum.title' | transloco }}</h1>
      <p class="last-updated">{{ 'legal.impressum.intro' | transloco }}</p>

      <section class="legal-section">
        <h2>{{ 'legal.impressum.s1.h' | transloco }}</h2>
        <ul>
          <li>
            <strong>{{ 'legal.impressum.s1.company' | transloco }}</strong>
          </li>
          <li>{{ 'legal.impressum.s1.tradingAs' | transloco }}</li>
          <li>{{ 'legal.impressum.s1.address' | transloco }}</li>
          <li>{{ 'legal.impressum.s1.reg' | transloco }}</li>
          <li>{{ 'legal.impressum.s1.tax' | transloco }}</li>
          <li>{{ 'legal.impressum.s1.regAuthority' | transloco }}</li>
        </ul>
      </section>

      <section class="legal-section">
        <h2>{{ 'legal.impressum.s2.h' | transloco }}</h2>
        <ul>
          <li>
            {{ 'legal.impressum.s2.emailLabel' | transloco }}:
            <a [href]="'mailto:' + contact.email">{{ contact.email }}</a>
          </li>
          <li>
            {{ 'legal.impressum.s2.supportLabel' | transloco }}:
            {{ 'legal.impressum.s2.supportInApp' | transloco }}
          </li>
        </ul>
      </section>

      <section class="legal-section">
        <h2>{{ 'legal.impressum.s3.h' | transloco }}</h2>
        <p>{{ 'legal.impressum.s3.p' | transloco }}</p>
      </section>

      <section class="legal-section">
        <h2>{{ 'legal.impressum.s4.h' | transloco }}</h2>
        <p>{{ 'legal.impressum.s4.p1' | transloco }}</p>
        <p>
          <a
            href="https://ec.europa.eu/consumers/odr"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://ec.europa.eu/consumers/odr
          </a>
        </p>
        <p>{{ 'legal.impressum.s4.p2' | transloco }}</p>
      </section>

      <section class="legal-section">
        <h2>{{ 'legal.impressum.s5.h' | transloco }}</h2>
        <p>{{ 'legal.impressum.s5.p' | transloco }}</p>
      </section>
    </div>
  </main>
</div>
